export const RoutingAction = {
    SHOW_REQUEST: 'ROUTING_SHOW_REQUEST',
    HIDDEN_REQUEST: 'ROUTING_HIDDEN_REQUEST',
};
